export default __webpack_public_path__ + "static/media/030-diving.2c225c40.svg";